/**
 * 通行帳密表單：useActionState 呼叫 accessAction；對了 action 直接 redirect，錯了回錯誤訊息。
 */
"use client";

import { useActionState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { accessAction, type AccessState } from "@/lib/actions/access";

const INITIAL: AccessState = { error: null };

export function AccessForm({ next }: { next: string }) {
  const [state, action, pending] = useActionState(accessAction, INITIAL);
  return (
    <form action={action} className="mt-5 flex flex-col gap-4">
      <input type="hidden" name="next" value={next} />
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="user">帳號</Label>
        <Input id="user" name="user" data-inspect="access.user" autoComplete="username" autoFocus required />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="code">密碼</Label>
        <Input id="code" name="code" data-inspect="access.code" type="password" autoComplete="current-password" required />
      </div>
      {state.error && <p role="alert" className="text-sm font-medium text-destructive">{state.error}</p>}
      <Button type="submit" size="lg" disabled={pending} className="mt-1 h-10 w-full" data-inspect="access.submit">
        {pending ? "確認中…" : "進入"}
      </Button>
    </form>
  );
}
